import { useState } from "react";

import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TextBoxEditWithModal = (props) => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(props.value);

    return (
        <>
            <div>
                <Button variant="link" size="sm" className="me-2 p-0" onClick={() => setOpen(true)}>
                    <FontAwesomeIcon icon={["fas", "edit"]} />
                </Button>
                {props.value}
            </div>

            <Modal show={open} onHide={() => setOpen(false)} centered>
                <Modal.Header closeButton>{props.title ?? "แก้ไข"}</Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        <Form.Control type="email" value={value} onChange={(e) => setValue(e.target.value)} />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="light" onClick={() => setOpen(false)}>
                        ยกเลิก
                    </Button>
                    <Button
                        onClick={() => {
                            setOpen(false);
                            props.onChange?.(value);
                        }}
                    >
                        เปลี่ยน
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TextBoxEditWithModal;
